import React, { useReducer } from "react";

const initial = {
  id: null,
  error: null,
  state: null,
} as any;
export const TransactionContext = React.createContext(null);

export const TransactionProvider: React.FC = ({ children }) => {
  const transactionReducer = (state: any, action: any) => {
    switch (action.type) {
      case "transactionPending":
        return {
          id: action.id,
          state: "pending",
        };
      case "transactionCompleted":
        return {
          ...action.transaction,
          state: "completed",
          id: action.id,
        };
      case "transactionError":
        return {
          error: action.error,
          state: "failed",
          id: action.id,
        };
      case "reset":
        return {
          id: null,
          error: null,
          state: null,
        };
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(transactionReducer, initial);

  return (
    <TransactionContext.Provider value={[state, dispatch]}>
      {children}
    </TransactionContext.Provider>
  );
};
